<div class="scanner-viewport" (click)="refocus()">
  <video #video class="scanner-video" [class.hidden]="error()" autoplay muted playsinline></video>

  @if (!error()) {
    <div
      class="scan-region"
      [class.scan-region-hit]="lastCode()"
      [style.left.%]="scanRegion.x * 100"
      [style.top.%]="scanRegion.y * 100"
      [style.width.%]="scanRegion.width * 100"
      [style.height.%]="scanRegion.height * 100"
    ></div>
  }

  @if (starting() && !error()) {
    <div class="scanner-overlay">
      <p-progress-spinner strokeWidth="6" fill="transparent" animationDuration="1s" [style]="{ width: '48px', height: '48px' }" />
    </div>
  }

  @if (error(); as error) {
    <div class="scanner-error">
      <mat-icon [size]="48">no_photography</mat-icon>
      <span>{{ 'barcodeScanner.errors.' + error | translate }}</span>
      @if (error !== 'insecure') {
        <p-button [label]="'barcodeScanner.retry' | translate" severity="secondary" (onClick)="retry()" />
      }
    </div>
  }
</div>

@if (!error()) {
  <p class="text-center text-sm mt-2 opacity-75">{{ 'barcodeScanner.hint' | translate }}</p>
}

@if (zoomRange(); as range) {
  @if (!error()) {
    <div class="flex items-center gap-3 mt-3 px-1">
      <mat-icon [size]="20">zoom_out</mat-icon>
      <p-slider
        class="grow"
        [min]="range.min"
        [max]="range.max"
        [step]="range.step || 0.1"
        [ngModel]="zoom()"
        (ngModelChange)="setZoom($event)"
        [ariaLabel]="'barcodeScanner.zoom' | translate"
      />
      <mat-icon [size]="20">zoom_in</mat-icon>
    </div>
  }
}

@if (mode === 'continuous' && scannedCodes().length > 0) {
  <div class="flex items-center gap-2 mt-2 text-sm">
    <mat-icon [size]="18">check_circle</mat-icon>
    <span class="truncate">{{ lastCode() }}</span>
    <span class="ml-auto opacity-75 whitespace-nowrap">
      {{ 'barcodeScanner.scannedCount' | translate: { count: scannedCodes().length } }}
    </span>
  </div>
}

<div class="flex flex-wrap items-center gap-2 mt-4">
  @if (cameras().length > 1) {
    <p-select
      class="grow min-w-0"
      [options]="cameras()"
      optionLabel="label"
      optionValue="deviceId"
      [ngModel]="selectedCameraId()"
      (ngModelChange)="selectCamera($event)"
      [disabled]="starting()"
      appendTo="body"
    >
      <ng-template #dropdownicon>
        <mat-icon [size]="20">cameraswitch</mat-icon>
      </ng-template>
    </p-select>
  } @else {
    <span class="grow"></span>
  }

  @if (torchSupported()) {
    <p-button
      [rounded]="true"
      [text]="!torchOn()"
      [severity]="torchOn() ? 'warn' : 'secondary'"
      [ariaLabel]="'barcodeScanner.torch' | translate"
      (onClick)="toggleTorch()"
    >
      <mat-icon [size]="20">{{ torchOn() ? 'flashlight_off' : 'flashlight_on' }}</mat-icon>
    </p-button>
  }

  <p-button [label]="'general.cancel' | translate" severity="secondary" (onClick)="cancel()" />
  @if (mode === 'continuous') {
    <p-button [label]="'barcodeScanner.done' | translate" (onClick)="done()" />
  }
</div>
